import AirClassic from '../icons/serviceIcons/AirClassic';
import AirExpress from '../icons/serviceIcons/AirExpress';
import CollectionService from '../icons/serviceIcons/CollectionService';
import Coverage from '../icons/serviceIcons/Coverage';
import DPDClassic from '../icons/serviceIcons/DPDClassic';
import DPDDirectLite from '../icons/serviceIcons/DPDDirectLite';
import EasyCustoms from '../icons/serviceIcons/EasyCustoms';
import EuropeanService from '../icons/serviceIcons/EuropeanService';
import NextDay from '../icons/serviceIcons/NextDay';
import PrinterlessDropOff from '../icons/serviceIcons/PrinterlessDropOff';
import RealtimeTracking from '../icons/serviceIcons/RealtimeTracking';
import Saturday from '../icons/serviceIcons/Saturday';
import Sunday from '../icons/serviceIcons/Sunday';
import ToShop from '../icons/serviceIcons/ToShop';
import TwoDay from '../icons/serviceIcons/TwoDay';
import WorldwideService from '../icons/serviceIcons/WorldwideService';

export const CHOOSE_FROM = 'Choose from';

export const NETWORK_MARKETING_DETAILS = theme => ({
  // Next day
  '2^12': {
    Icon: ({ sx }) => <NextDay sx={sx} />,
    bannerText: 'Fastest',
    description: 'Reliable, next-day delivery. From your door to theirs',
    deliveryTiming: 'Delivered next working day',
    bannerColor: theme.vars.palette.info.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <CollectionService sx={sx} />,
        text: 'Collection service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // Two day
  '2^11': {
    Icon: ({ sx }) => <TwoDay sx={sx} />,
    bannerText: 'Most popular',
    description: 'Reliable, 2 day delivery. From your door to theirs',
    deliveryTiming: 'Delivered within 2 days',
    bannerColor: theme.vars.palette.primary.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <CollectionService sx={sx} />,
        text: 'Collection service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // Saturday
  '2^71': {
    Icon: ({ sx }) => <Saturday sx={sx} />,
    bannerText: 'Weekend delivery',
    description: 'Reliable, Saturday delivery. From your door to theirs',
    deliveryTiming: 'Delivered on Saturday',
    bannerColor: theme.vars.palette.info.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <CollectionService sx={sx} />,
        text: 'Collection service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // Sunday
  '2^75': {
    Icon: ({ sx }) => <Sunday sx={sx} />,
    bannerText: 'Weekend delivery',
    description: 'Reliable, Sunday delivery. From your door to theirs',
    deliveryTiming: 'Delivered on Sunday',
    bannerColor: theme.vars.palette.info.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <CollectionService sx={sx} />,
        text: 'Collection service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // Shop to shop
  '2^91': {
    Icon: ({ sx }) => <ToShop sx={sx} />,
    bannerText: 'Best value',
    description:
      'Easy for you. Convenient for them. Drop off at a shop, they pick up locally',
    deliveryTiming: 'Delivered within 3-4 days',
    bannerColor: theme.vars.palette.primary.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <PrinterlessDropOff sx={sx} />,
        text: 'Printerless drop-off',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // DPD Classic
  '2^19': {
    Icon: ({ sx }) => <DPDClassic sx={sx} />,
    bannerText: '1hr Delivery Advised',
    description:
      'One of the fastest, most reliable delivery services in Europe',
    deliveryTiming: 'Typical transit times of 3 days',
    bannerColor: theme.vars.palette.primary.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <EuropeanService sx={sx} />,
        text: 'European Service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // DPD direct lite
  '2^20': {
    Icon: ({ sx }) => <DPDDirectLite sx={sx} />,
    bannerText: 'Best value',
    description: 'Worldwide service designed for small parcels to 2kg',
    deliveryTiming:
      'Typical transit times of 6 days Europe and 8 days rest of world',
    bannerColor: theme.vars.palette.primary.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <EasyCustoms sx={sx} />,
        text: 'Easy Customs',
      },
      {
        Icon: ({ sx }) => <WorldwideService sx={sx} />,
        text: 'Worldwide Service',
      },
      // Is realtime tracing the same as tracked service?
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Tracked service',
      },
    ],
  },
  // Air express
  '2^50': {
    Icon: ({ sx }) => <AirExpress sx={sx} />,
    bannerText: 'Fastest',
    description: 'Our fastest worldwide delivery to over 200 countries',
    deliveryTiming: 'Typical transit times of 3 days worldwide',
    bannerColor: theme.vars.palette.info.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <WorldwideService sx={sx} />,
        text: 'Worldwide service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  // Air classic
  '2^60': {
    Icon: ({ sx }) => <AirClassic sx={sx} />,
    bannerText: 'Global value',
    description:
      'Perfect for non-time sensitive shipments that require full tracking',
    deliveryTiming: 'Typical transit times of 4 days worldwide',
    bannerColor: theme.vars.palette.primary.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <Coverage sx={sx} />,
        text: 'Free £50 parcel cover',
      },
      {
        Icon: ({ sx }) => <WorldwideService sx={sx} />,
        text: 'Worldwide service',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Realtime tracking',
      },
    ],
  },
  CITYSPRINT_SAMEDAY: {
    Icon: ({ sx }) => <NextDay sx={sx} />,
    bannerText: 'Same Day',
    description: 'Same Day courier collection and delivery',
    deliveryTiming: 'Delivered the Same Day when you book before the cut-off',
    bannerColor: theme.vars.palette.primary.main,
    sellingPoints: [
      {
        Icon: ({ sx }) => <CollectionService sx={sx} />,
        text: 'Collection and delivery today',
      },
      {
        Icon: ({ sx }) => <RealtimeTracking sx={sx} />,
        text: 'Tracking available',
      },
    ],
  },
});
